<template>
  <div class="neo-hero">
    <img class="neo-hero__bg" :src="getWebsiteImage('neo-bg.png')" alt="BG" />
    <div class="neo-container">
      <neo-nav @scroll="$emit('scroll', $event)" />
      <div class="neo-content">
        <div class="neo-content__desc">
          <div class="text" data-aos="fade-up">
            <h1>Money Transfers <br />Made for You.</h1>
            <p>
              Send Money with NEO - It's Easy and Free of Transfer Charges!
              Boost your credit score with every transfer. <br />Want to pay now
              or later? You choose!
            </p>
            <div class="offer">
              <h6>
                $1
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#000"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M5 12h13M12 5l7 7-7 7" />
                </svg>
                ₦1,100
              </h6>
              <p>*Available for a limited time</p>
            </div>

            <el-row type="flex" justify="center">
              <el-col :md="16" :lg="24">
                <neo-signup-form />
              </el-col>
            </el-row>
            <p style="font-size: 18px">
              Reserve your exclusive spot ahead of our product launch. Unlock
              premium benefits for you and your loved ones.
            </p>
          </div>
          <div class="image" data-aos="flip-left">
            <img :src="getWebsiteImage('app-mockup.gif')" alt="NeoCard" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NeoNav from "@/components/Website/NeoNav";
import NeoSignupForm from "@/components/Website/NeoSignupForm.vue";
export default {
  name: "NeoHero",
  components: { NeoSignupForm, NeoNav },
  data() {
    return {};
  },
  methods: {
    goToDashboard() {
      this.$router.push({ name: "home.index" });
    },
  },
};
</script>

<style lang="scss">
.neo-content {
  min-height: 100vh;
  padding: 20px 0 60px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  &__desc {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    grid-column-gap: 80px;

    .text {
      h1 {
        margin-bottom: 20px;
      }

      p {
        width: 90%;
        font-size: 1.35rem;
      }
      .offer {
        margin: 20px 0;

        h6 {
          display: flex;
          align-items: center;

          svg {
            margin: 0 10px;
          }
        }
        p {
          font-size: 16px;
        }
      }
    }
    .image {
      text-align: center;
      img {
        height: 550px;
        width: auto;
        //animation: hover 10s cubic-bezier(0.36, 0.07, 0.19, 0.97) infinite;
        //transform: translate3d(0, 0, 0);
        //backface-visibility: hidden;
        //perspective: 1000px;
      }
    }
  }

  &__cta {
    display: flex;
    justify-content: center;
  }
}

@keyframes hover {
  10%,
  90% {
    transform: translate3d(0, -1px, 0);
  }

  20%,
  80% {
    transform: translate3d(0, 4px, 0);
  }

  30%,
  50%,
  70% {
    transform: translate3d(0, -8px, 0);
  }

  40%,
  60% {
    transform: translate3d(0, 8px, 0);
  }
}

@media (max-width: 1368px) {
  .neo-content {
    &__desc {
      .image {
        margin-top: 50px;
        img {
          height: 500px;
        }
      }
    }
  }
}

@media (max-width: 1200px) {
  .neo-content {
    &__desc {
      grid-template-columns: 1fr;
      margin-bottom: 50px;

      .offer {
        text-align: center;

        h6 {
          justify-content: center;
        }
      }
      .text {
        text-align: center;

        h1 {
          font-size: 3.2rem;
        }

        p {
          font-size: 1.5rem;
          width: 100%;
        }
      }

      .image {
      }
    }
  }
}

@media (max-width: 768px) {
  .neo-content {
    &__desc {
      flex-direction: column-reverse;
      align-items: center;
      margin-bottom: 50px;

      .text {
        width: 100%;

        p {
          width: 100%;
        }
      }

      .image img {
        height: 420px;
      }
    }
  }
}

@media (max-width: 600px) {
  .neo-content {
    &__desc {
      margin-bottom: 20px;

      .text {
        h1 {
          font-size: 2rem;
        }

        p {
          width: 90%;
          margin: auto;
          font-size: 1.25rem;
        }
      }
      .image {
        margin-top: 30px;
        img {
          height: 350px;
        }
      }
    }
  }
}
</style>
